import React from "react";
import { Alert, Text } from "../../../../components";
import TextStyled from "./AlertaParaSaberMais.Style";

const AlertaParaSaberMais = () => {
  return (
    <Alert>
      <TextStyled as={Text} size="sm">
        <strong>Importante</strong>: Este produto não é mais comercializado pela
        Caixa Seguradora desde <strong>fevereiro de 2021</strong>. Se você
        contratou o Seguro Habitacional <strong>depois de 15/02/2021</strong> e
        quer saber mais, por favor, entre em contato diretamente com a agência
        da Caixa onde foi realizado o seu financiamento.
      </TextStyled>
    </Alert>
  );
};

export default AlertaParaSaberMais;
